import { Injectable } from '@angular/core';
import OidcConfig from '../../../assets/oidc-config.json';
import { IOidcConfig } from '../models/oidc-config.model';
@Injectable({
  providedIn: 'root',
})
export class OIDCConfigService {
  private config: any;
  public isLoaded: boolean = false;
  public configIsValid: boolean = false;

  constructor() {}

  public load(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.config = { ...OidcConfig };
      this.configIsValid = this.validate(this.config);

      this.isLoaded = true;
      resolve();
    });
  }

  public getConfiguration(): IOidcConfig {
    return this.config;
  }

  private validate(config: IOidcConfig): boolean {
    let isConfigured = true;
    const entries = Object.entries(config);
    entries.forEach((entry: [string, any]) => {
      const value = entry[1];
      if (typeof value === 'string') {
        if ((value.startsWith('__') && value.endsWith('__')) || value.length === 0) {
          isConfigured = false;
        }
      }
    });

    return isConfigured;
  }
}
